import chain from '@/lib/axios-chain'
import { decodeQuitList } from '@/lib/mix-utils'
// 获取具有对应权限的人员列表
// export const getPeronsDatas = () => chain.create('/user/team/getauthuserslistbypk', 'get')
export const getPeronsDatas = () => chain.create('/user/team/memberlist', 'get')
export const getMenuList = () => chain.create('/inquiry/dimission/getmenu', 'get')

// 获取具有对应权限的人员列表
// export const getPeronListsDatas = () => chain.create('/inquiry/dimission/index', 'get')
// 获取离职信息列表
export const getPeronListsDatas = () =>
  chain
    .create('/inquiry/dimission/index', 'get')
    .decode(async (payload) => {
      const datas = await decodeQuitList(payload)
      return datas
    })
// 获取离职信息列表
export const getFilterListsDatas = () =>
  chain
    .create('/inquiry/dimission/query', 'post')
    .decode(async (payload) => {
      const datas = await decodeQuitList(payload)
      return datas
    })

// 获取具有对应权限的团队组人
export const getTeamPersonList = () => chain.create('/user/team/getauthusersinfobypk', 'get')

// 交接
export const subQuitForm = () => chain.create('/inquiry/dimission/handover ', 'post')

// 离职筛选
export const quitFilter = () => chain.create('/inquiry/dimission/getquery', 'get')
